/** @format */

const template = `
<div class="row">
  <div class="col-md-12">
    <div class="select-wrapper">
      <select
        class="form-select"
        name="{{ctrl.name}}"
        aria-label="{{'STUDIES.COURSE_UNITS_BASICINFO.GRADE_SCALE' | translate}}"
        ng-required="ctrl.required"
        ng-model="ctrl.ngModel.$viewValue"
        ng-options="gradeScale.name | localizedString for gradeScale in ctrl.possibleGradeScales track by gradeScale.id"
        ng-change="ctrl.onChange()"
        ng-disabled="ctrl.disable">
      </select>
    </div>

    <ul
      class="error-list"
      ng-if="ctrl.form[ctrl.name].$invalid"
      ng-messages="ctrl.form[ctrl.name].$error"
      ng-messages-multiple="true"
      role="alert">
      <li ng-message="required" translate>SIS_COMPONENTS.GRADE_SCALE.GRADE_SCALE_SELECT_EDITOR.REQUIRED</li>
    </ul>
  </div>
</div>
`;
export default template;
